import { Component, Input, OnChanges } from '@angular/core';
import { ChartConfiguration } from 'chart.js';
import { ReminderDistributionItem } from '../../../../../services/reminder-analytics/reminder-analytics.model';

@Component({
    selector: 'app-reminder-area-chart',
    templateUrl: './reminder-area-chart.component.html',
    styleUrls: ['./reminder-area-chart.component.scss'],
})
export class ReminderAreaChartComponent implements OnChanges {
    @Input() data: ReminderDistributionItem[] = [];

    chartData: ChartConfiguration<'bar'>['data'] = { labels: [], datasets: [] };
    chartOptions: ChartConfiguration<'bar'>['options'] = {
        responsive: true,
        maintainAspectRatio: false,
        indexAxis: 'y',
        plugins: { legend: { display: false } },
        scales: {
            x: { beginAtZero: true, ticks: { precision: 0 } },
            y: { grid: { display: false } },
        },
    };

    private fallbackPalette = ['#3a7bd5', '#10b981', '#f59e0b', '#ef4444', '#8b5cf6', '#ec4899', '#06b6d4', '#f97316', '#14b8a6', '#6366f1'];

    ngOnChanges(): void {
        if (!this.data || this.data.length === 0) return;
        this.chartData = {
            labels: this.data.map((d) => d.label),
            datasets: [{ data: this.data.map((d) => d.count), backgroundColor: this.data.map((_, i) => this.fallbackPalette[i % this.fallbackPalette.length]), borderRadius: 4 }],
        };
    }
}
